import Uninvoiced from 'components/invoices'
import Invoices from 'components/invoices'
import { appliesMeta } from '@/utils/functions/applies-meta'

export default appliesMeta({
    requiresAuth: true,
    template: 'chameleon',
    can: 'read invoices'
  },[
    {
      path: '/invoices',
      component: Invoices.Invoices,
      name: 'invoices.index'
    },
    {
      path: '/invoices/uninvoiced',
      component: Uninvoiced.Uninvoiced,
      name: 'invoices.uninvoiced'
    },
    {
      path: '/invoices/:invoice_id',
      component: Invoices.Show,
      name: 'invoices.show',
    },
  ]
)